import { config } from "../../config.js";
import { Table } from 'react-bootstrap';

export const TradeTable = ({ tradeLog, riskSize, algoName }) => {
    let wins = 0;
    let losses = 0;
    let profit = 0;
    const testArray = tradeLog ?? [];
    for (let trade of testArray) {
        let pricePerPoint;
        if (trade.ticker) {
            pricePerPoint = config.symbols[trade.ticker.substring(0, trade.ticker.length - 2)].pricePerPoint;
        } else {
            pricePerPoint = config.symbols.ES.pricePerPoint;
        }
        if (trade.status === 'Win') {
            wins = wins + 1;
            if (trade.entryStyle === 'sma' && trade.lastPrice) {
                profit = profit + Math.round(riskSize / trade.stopSize / pricePerPoint) * pricePerPoint * Math.abs(trade.lastPrice - trade.fillPrice);
            } else {
                profit = profit + Math.round(riskSize / trade.stopSize / pricePerPoint) * pricePerPoint * trade.profitTarget;
            }

        } else if (trade.status === 'Loss') {
            losses = losses + 1;
            if (trade.entryStyle === 'sma' && trade.lastPrice) {
                profit = profit - Math.round(riskSize / trade.stopSize / pricePerPoint) * pricePerPoint * Math.abs(trade.lastPrice - trade.fillPrice);
            } else {
                profit = profit - Math.round(riskSize / trade.stopSize / pricePerPoint) * pricePerPoint * trade.stopSize;
            }

        }
    }

    return (
        <div>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Detection Time</th>
                        {/* <th>Filled Time</th> */}
                        {/* <th>End Time</th> */}
                        <th>Trade Type</th>
                        <th>Fill Price</th>
                        <th>Stop Size</th>
                        <th>Profit Target</th>
                        {/* <th>Trade Status</th> */}
                        <th>Algorithm - Ticker - Timeframe</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        tradeLog && tradeLog.length ? tradeLog.map(trade => {
                            return (
                                <tr key={trade.timestamp + trade.fillPrice + algoName + trade.ticker + trade.timeframe}>
                                    <td>{trade.timestamp}</td>
                                    {/* <td>{trade.filledTimestamp ? trade.filledTimestamp : 'N/A'}</td> */}
                                    {/* <td>{trade.endTimestamp ? trade.endTimestamp : 'N/A'}</td> */}
                                    <td>{trade.type.includes('BUY') ? 'BUY' : 'SELL'}</td>
                                    <td>{Math.round(trade.fillPrice * 100) / 100}</td>
                                    <td>{Math.round(trade.stopSize * 100) / 100}</td>
                                    <td>{Math.round(trade.profitTarget * 100) / 100}</td>
                                    {/* <td>{trade.status}</td> */}
                                    <td>{algoName.toUpperCase() + ' - ' + trade.ticker + ' - ' + trade.timeframe}</td>
                                </tr>
                            );
                        }) : []
                    }
                </tbody>
            </Table>
        </div>
    )
};